import { Switch } from 'antd'
import { Rule } from 'antd/lib/form'

import {
  ToggleCaptureBlock as ToggleCaptureBlockType,
  ToggleOptionsField,
} from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

type Props = {
  block: ToggleCaptureBlockType
  rules: Rule[]
}

const getValue = (
  value: ToggleOptionsField,
  defaultState: ToggleOptionsField
) => {
  if (value === 'on') return true
  if (value === 'off') return false
  if (defaultState === 'on') return true
  if (defaultState === 'off') return false
  return false
}

export const ToggleCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { defaultState, onLabel, offLabel, value } = block

  return (
    <CaptureBlockFormItem
      valuePropName="checked"
      initialValue={getValue(value, defaultState)}
      rules={rules}
      block={block}
    >
      <Switch checkedChildren={onLabel} unCheckedChildren={offLabel} />
    </CaptureBlockFormItem>
  )
}
